<ion-footer id="footer">
  <ion-grid>
    <ion-row>
      <ion-col [ngClass]="this.manager.Navi.isSelected('scan') ? 'footerSelected' : ''">
        <ion-item button detail-icon=“none” lines="none" (click)="manager.Navi.navigateTo('scan')">
          <div class="footerWrapper">
            <ion-icon name="qr-code" color="primary-contrast"></ion-icon>
            <ion-label> {{manager.Trad.Parse("STR_SCAN")}}</ion-label>
          </div>
        </ion-item>
      </ion-col>
      <ion-col [ngClass]="this.manager.Navi.isSelected('crea') ? 'footerSelected' : ''">
        <ion-item button detail-icon=“none” lines="none" (click)="manager.Navi.navigateTo('crea')">
          <div class="footerWrapper">
            <ion-icon name="flash" color="primary-contrast"></ion-icon>
            <ion-label> {{manager.Trad.Parse("STR_CREA_ASK")}}</ion-label>
          </div>
        </ion-item>
      </ion-col>
      <ion-col [ngClass]="this.manager.Navi.isSelected('asks') ? 'footerSelected' : ''">
        <ion-item button detail-icon=“none” lines="none" (click)="manager.Navi.navigateTo('asks')">
          <div class="footerWrapper">
            <ion-icon name="chatbubble" color="primary-contrast"></ion-icon>
            <ion-label> {{manager.Trad.Parse("STR_ASKS_FOOT")}}</ion-label>
            <ion-badge *ngIf="manager.NotifiedAsk>0" color="primary">{{manager.NotifiedAsk}}</ion-badge>
          </div>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>

